import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ParticlesDensity } from "./ParticlesDensity";
export var ParticlesNumber = /*#__PURE__*/function () {
  function ParticlesNumber() {
    _classCallCheck(this, ParticlesNumber);

    this.density = new ParticlesDensity();
    this.limit = 0;
    this.value = 0;
  }

  _createClass(ParticlesNumber, [{
    key: "max",
    get: function get() {
      return this.limit;
    },
    set: function set(value) {
      this.limit = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$limit;

      if (!data) {
        return;
      }

      this.density.load(data.density);
      var limit = (_data$limit = data.limit) !== null && _data$limit !== void 0 ? _data$limit : data.max;

      if (limit !== undefined) {
        this.limit = limit;
      }

      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }]);

  return ParticlesNumber;
}();